import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useAuth } from '../../hooks/useAuth';
import ThemeToggle from './ThemeToggle';
import Button from '../common/Button';

const Header = ({ onMenuClick }) => {
  const { userProfile, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 safe-top">
      <div className="flex items-center justify-between px-4 lg:px-6 py-3">
        <div className="flex items-center">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 mr-2"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <h1 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white">
            Jira Tracker
          </h1>
        </div>
        
        <div className="flex items-center space-x-2 lg:space-x-4">
          <ThemeToggle />
          
          {userProfile && (
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="hidden sm:flex items-center space-x-2">
                {userProfile.avatarUrl ? (
                  <img
                    src={userProfile.avatarUrl}
                    alt={userProfile.displayName}
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-medium">
                      {userProfile.displayName?.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300 hidden md:block">
                  {userProfile.displayName}
                </span>
              </div>
              
              <Button
                variant="outline"
                size="small"
                onClick={handleLogout}
                className="text-xs lg:text-sm"
              >
                Logout
              </Button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;